<section class="admin-page ct-page">
  <div class="ct-toolbar">
    <div>
      <p class="subtitle">{{ 'users.subtitle' | t }}</p>
    </div>
    <button class="ct-btn ct-btn-primary" type="button" (click)="openCreate()">
      {{ 'users.new' | t }}
    </button>
  </div>

  <div class="ct-card ct-table-wrap">
    <table class="ct-table">
      <thead>
        <tr>
          <th>{{ 'users.email' | t }}</th>
          <th>{{ 'common.name' | t }}</th>
          <th>{{ 'users.role' | t }}</th>
          <th>{{ 'users.scope' | t }}</th>
          <th class="col-status">{{ 'common.status' | t }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @if (loading()) {
          <tr><td colspan="6">{{ 'common.loading' | t }}</td></tr>
        } @else if (items().length === 0) {
          <tr><td colspan="6">{{ 'users.empty' | t }}</td></tr>
        } @else {
          @for (item of items(); track item.id) {
            <tr>
              <td>{{ item.email }}</td>
              <td>{{ item.name }}</td>
              <td>{{ roleKey(item.role) | t }}</td>
              <td>{{ scopeLabel(item) }}</td>
              <td class="col-status">
                <span class="ct-badge" [class.ct-badge-success]="item.isActive" [class.ct-badge-muted]="!item.isActive">
                  {{ (item.isActive ? 'common.active' : 'common.inactive') | t }}
                </span>
              </td>
              <td class="actions">
                @if (canImpersonate(item)) {
                  <button class="ct-btn ct-btn-ghost ct-btn-sm" type="button" (click)="impersonate(item)">
                    {{ 'users.impersonate' | t }}
                  </button>
                }
                @if (canEdit(item)) {
                  <button class="ct-btn ct-btn-ghost ct-btn-sm" type="button" (click)="openEdit(item)">
                    {{ 'common.edit' | t }}
                  </button>
                }
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>
</section>

@if (dialogOpen()) {
  <div class="ct-dialog-backdrop" (click)="closeDialog()">
    <div class="ct-dialog" (click)="$event.stopPropagation()" role="dialog" aria-modal="true">
      <header class="ct-dialog-head"><h2>{{ (editingId() ? 'users.edit' : 'users.new') | t }}</h2>        <button type="button" class="ct-dialog-close" (click)="closeDialog()" [attr.aria-label]="'common.close' | t">
          <span class="material-symbols-outlined" aria-hidden="true">close</span>
        </button></header>
      <form [formGroup]="form" (ngSubmit)="save()">
        <div class="ct-dialog-body">
        <div class="ct-form-grid">
          <div class="ct-field">
            <label for="user-email">{{ 'users.email' | t }}</label>
            <input id="user-email" class="ct-input" type="email" formControlName="email" autocomplete="off" />
            @if (form.controls.email.touched && form.controls.email.hasError('email')) {
              <p class="hint error-hint">{{ 'users.emailInvalid' | t }}</p>
            }
            @if (form.controls.email.touched && form.controls.email.hasError('required')) {
              <p class="hint error-hint">{{ 'users.emailRequired' | t }}</p>
            }
          </div>
          <div class="ct-field">
            <label for="user-name">{{ 'common.name' | t }}</label>
            <input id="user-name" class="ct-input" formControlName="name" />
          </div>
          <div class="ct-field">
            <label for="user-password">{{ 'users.password' | t }}</label>
            <input id="user-password" class="ct-input" type="password" formControlName="password" autocomplete="new-password" />
            @if (form.controls.password.touched && form.controls.password.hasError('minlength')) {
              <p class="hint error-hint">{{ 'users.passwordMin' | t }}</p>
            }
            @if (form.controls.password.touched && form.controls.password.hasError('required')) {
              <p class="hint error-hint">{{ 'users.passwordRequired' | t }}</p>
            }
          </div>
          @if (isPortalAdmin()) {
            <div class="ct-field">
              <label for="user-role">{{ 'users.role' | t }}</label>
              <select id="user-role" class="ct-select" formControlName="role">
                @for (role of assignableRoles(); track role) {
                  <option [value]="role">{{ roleKey(role) | t }}</option>
                }
              </select>
            </div>
          }
          @if (selectedRole() === 'BusinessAdmin' || !isPortalAdmin()) {
            <div class="ct-field">
              <label>{{ 'users.business' | t }}</label>
              <div class="business-checks">
                @for (biz of actor()?.businesses ?? []; track biz.id) {
                  <label class="check-row">
                    <input
                      type="checkbox"
                      [checked]="isBusinessSelected(biz.id)"
                      [disabled]="form.controls.businessIds.disabled"
                      (change)="toggleBusiness(biz.id, $any($event.target).checked)"
                    />
                    {{ biz.name }}
                  </label>
                }
              </div>
            </div>
          }
          <div class="ct-field">
            <label>
              <input type="checkbox" formControlName="isActive" /> {{ 'common.active' | t }}
            </label>
          </div>
        </div>
        </div>
        <div class="ct-dialog-actions">
          <button class="ct-btn ct-btn-ghost" type="button" (click)="closeDialog()">
            {{ 'common.cancel' | t }}
          </button>
          <button class="ct-btn ct-btn-primary" type="submit">{{ 'common.save' | t }}</button>
        </div>
      </form>
    </div>
  </div>
}
